/*
 * Busy state for a submitting form.
 *
 * The product form is a native POST to /cart/add, so between the click and the
 * cart page arriving the only feedback was the browser's own tab spinner, and
 * the button looked exactly as it did before it was pressed. On a slow
 * connection that reads as a click that did not register, and the usual
 * response to that is a second click.
 *
 * Opt in with data-peanut-busy on the form. Each submit button names its own
 * busy label in data-busy-label and keeps its resting label in the first span,
 * which is the shape every .peanut-btn already has. Buttons that point at the
 * form from outside it with form="id" are included, which is how the mobile
 * sticky bar stays in step with the inline button.
 *
 * Nothing here submits anything. With this file absent the form posts exactly
 * as before, only without the feedback.
 */
(function () {
  'use strict';

  // Any section with a posting form may load this file, and two script tags for
  // one URL still execute twice, which would bind every listener twice and let
  // the second one read the first one's busy flag as a repeat click.
  if (window.peanutSubmitStateInit) return;
  window.peanutSubmitStateInit = true;

  function buttonsFor(form) {
    var inside = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"]'));
    // getAttribute, never form.id. The product form holds radios named "id",
    // and a named control shadows the property of the same name, so form.id
    // was that set of radios and the selector below matched nothing: the
    // sticky bar's button never took the busy state this was written to give it.
    var id = form.getAttribute('id');
    if (!id) return inside;
    var outside = Array.prototype.slice.call(
      document.querySelectorAll('button[type="submit"][form="' + id + '"]')
    );
    return inside.concat(outside);
  }

  function setBusy(form, busy) {
    buttonsFor(form).forEach(function (button) {
      var label = button.querySelector('span');
      var text = button.getAttribute('data-busy-label');
      if (!label || !text) return;

      if (busy) {
        // Already busy. Setting it twice would save the busy label as the
        // resting one, and the button would read Adding for ever.
        if (button.hasAttribute('data-rest-label')) return;
        // Hold the resting width. The busy label is a different length, and in
        // the inline signup form a button that resizes drags the input with it.
        button.style.minWidth = button.offsetWidth + 'px';
        button.setAttribute('data-rest-label', label.textContent);
        label.textContent = text;
        button.setAttribute('aria-busy', 'true');
      } else if (button.hasAttribute('data-rest-label')) {
        label.textContent = button.getAttribute('data-rest-label');
        button.removeAttribute('data-rest-label');
        button.removeAttribute('aria-busy');
        button.style.minWidth = '';
      }
    });

    if (busy) form.setAttribute('data-submitting', 'true');
    else form.removeAttribute('data-submitting');
  }

  // A handle for peanut-cart-sheet.js, which stops the native post and so
  // has to set and clear the busy state itself.
  window.peanutSubmitState = { set: setBusy };

  document.querySelectorAll('form[data-peanut-busy]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      // Someone else has already stopped this submit, so there is no request in
      // flight to report on.
      if (event.defaultPrevented) return;

      // The second click. The button is not given the disabled attribute,
      // because a disabled button drops focus and a keyboard user loses their
      // place; the guard lives here instead.
      if (form.hasAttribute('data-submitting')) {
        event.preventDefault();
        return;
      }

      setBusy(form, true);
    });
  });

  // Back from the cart, the browser restores this page from its cache exactly
  // as it was left, which is mid-submit. Without this the button reads Adding
  // for ever and the guard above swallows every click.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('form[data-submitting]').forEach(function (form) {
      setBusy(form, false);
    });
  });
})();
